// src/components/sales/form/QuantityInput.tsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { WEIGHT_UNITS } from '../../../utils/constants';

interface QuantityInputProps {
  quantity: string;
  unit: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  error?: string;
  disabled?: boolean;
}

export const QuantityInput: React.FC<QuantityInputProps> = ({
  quantity,
  unit,
  onChange,
  error,
  disabled = false
}) => {
  // Removed 'common' namespace – uses default
  const { t } = useTranslation();

  // Capitalize first letter manually to ensure fallback works
  const translatedQuantity = t('common.quantity');
  const labelQuantity = translatedQuantity?.charAt(0).toUpperCase() + translatedQuantity?.slice(1);

  return (
    <div className="space-y-2">
      <label htmlFor="quantity" className="block text-sm font-medium text-gray-700">
        {labelQuantity} *
      </label>
      <div className="grid grid-cols-3 gap-2">
        <div className="col-span-2">
          <input
            type="number"
            id="quantity"
            name="quantity"
            value={quantity}
            onChange={onChange}
            disabled={disabled}
            min="0"
            step="0.01"
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
            placeholder={labelQuantity}
          />
        </div>
        <select
          id="unit"
          name="unit"
          value={unit}
          onChange={onChange}
          disabled={disabled}
          className="w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
        >
          {WEIGHT_UNITS.map(({ value }) => (
            <option key={value} value={value}>
              {t(`common.units.${value}`)}
            </option>
          ))}
        </select>
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};
